import { StudentDocumentsTab } from '@features/student-documents/components/StudentDocumentsTab'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/documents')({
  component: RouteComponent,
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return <StudentDocumentsTab studentNo={studentNo} />
}
